import Api from '@/services/Api'

export default {
  getPackagings() {
    return Api().get("/packagings");
  },
  createPackaging(data) {
    return Api().post("/packagings", data);
  },
  deletePackaging(id) {
    return Api().delete(`/packagings/${id}`);
  },
  updatePackaging(id, data) {
    return Api().put(`/packagings/${id}`, data);
  },
  updatePackagingStock(sku, newStock) {
    return Api().put(`/packagings/stock/${sku}`, { newStock: newStock });
  },
  getPackagingLogs(sku) {
    return Api().get(`/packagings/logs/${sku}`);
  },
  getUniqueSkus() {
    return Api().get('/packagings/skus');
  },
  getPackagingSelection(skus) {
    console.log('Calling getPackagingSelection with SKUs:', skus);
    
    // Handle empty array case
    if (!skus || skus.length === 0) {
      console.warn('No SKUs provided to getPackagingSelection');
      return Promise.resolve({ status: 200, data: [] });
    }
    
    return Api().get('/packagings/selection/', {
      params: { skus: skus }
    }).then(response => {
      console.log('PackagingSelection response:', response);
      return response;
    }).catch(error => {
      console.error('Error in getPackagingSelection:', error);
      throw error;
    });
  }
}
